import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/perninoconsulting.webp';
import screenshot_target from '../../../images/letterfunnel/stefanlemmens.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Stefan Lemmens"
      firstname="Stefan"
      companyname="Pernino Consulting"
      competition="Blue Bricks en Highberg"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/stefanlemmens.js